import { Livewire } from '@shared/livewire.js'
import '@shared/forms/stripe.js'
import '@shared/forms/paypal.js'
import '@/Signups/Components/donations/donation-checkout.js'

Livewire.start()
